<template>
    <div v-if="image">
        <Image1 :src="image"></Image1>
    </div>
</template>

<script>
import Image1 from "../image";

export default {
    name: "HeaderImage",
    components: {
        Image1
    },
    props: {
        image: String
    }
}
</script>

<style scoped>
</style>
